var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBell = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.848,
    height: 32.967,
    viewBox: "0 0 28.848 32.967",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "bell-solid",
    d: "M16.484,2.06V3.3a10.309,10.309,0,0,1,8.242,10.1V14.6a12.38,12.38,0,0,0,3.123,8.216l.476.534a2.061,2.061,0,0,1-1.539,3.432H2.061a2.062,2.062,0,0,1-1.54-3.432L1,22.82A12.367,12.367,0,0,0,4.121,14.6V13.393A10.251,10.251,0,0,1,12.363,3.3V2.06a2.06,2.06,0,0,1,4.121,0Zm-2.06,30.907a4.122,4.122,0,0,1-2.917-1.2,4.225,4.225,0,0,1-1.2-2.917h8.242a4.111,4.111,0,0,1-4.121,4.121Z",
    transform: "translate(0)",
    fill: "#ffce05"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBell);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/bell.7ac1dc904766e0e3b2942a9128b328a8.svg";